import React from 'react';
import strings from 'strings';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import FPButtonMenu from 'UI/components/molecules/FPButtonMenu';

const { actions } = strings.searchProjects.preview;

/**
 * @param {Object} props
 * @param {boolean} [props.shouldShowRestoreButton]
 * @param {Array<MenuButtonItemsProps>} props.menuItems
 * @param {Function} [props.onOpenRestoreInterface]
 */
const SearchProjectsHeaderAction = ({
  shouldShowRestoreButton = false,
  menuItems,
  onOpenRestoreInterface = null
}) =>
  shouldShowRestoreButton ? (
    <FPActionButton text={actions.archivedSearchProject.title} onClick={onOpenRestoreInterface} />
  ) : (
    <FPButtonMenu
      title={actions.moreOptions.title}
      isIconButton
      variant="outlinePrimary"
      menuItems={menuItems}
    />
  );

export default SearchProjectsHeaderAction;
